function getHash(input) {
  // Compute a hash of the input string
  var hash = 0;
  for (var i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

export default function generateRandomColor(input) {
  // Use the hash function to map the input string to a color
  var hash = getHash(input);
  var color = '#' + ((hash & 0xffffff) | 0x1000000).toString(16).substring(1);
  return color;
}
